// Function to update the "Product Includes:" text
function updateProductIncludesText() {
  // Find all <h2> elements with the text "Product Includes:"
  var productIncludesElements = document.querySelectorAll('h2:contains("Product Includes:")');

  // Loop through the elements and update the text
  productIncludesElements.forEach(function(element) {
    element.textContent = 'สินค้าประกอบด้วย';
  });
}

// Create a MutationObserver to watch for changes to the DOM
var observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    // Check if the mutation affects the "Product Includes:" text
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      updateProductIncludesText();
    }
  });
});

// Start observing the document body for changes
document.addEventListener('DOMContentLoaded', function() {
  var bodyElement = document.querySelector('body');
  observer.observe(bodyElement, { childList: true, subtree: true, characterData: true });

  // Call the updateProductIncludesText function initially
  updateProductIncludesText();
});